import { PrimaryButton } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import PartnerContactsPanel from "./PartnerContactsPanel";
import { IPartnerContactProps } from "../../interfaces/PartnerView.interfaces";

export default function PartnerContact(props: IPartnerContactProps) {
  const [isContactOpen, { setTrue: openContactPanel, setFalse: dismissContactPanel }] = useBoolean(false);

  return (
    <div
      style={{
        marginLeft: 15
      }}
    >
      <div style={{ paddingLeft: 7, marginTop: 0 }}>
        <div style={{ paddingBottom: 10 }}>
          <strong>Contact Information :</strong>
        </div>
        <br />
        <br />
        <div>
          <PrimaryButton
            text="Show Contacts"
             onClick={openContactPanel}
            iconProps={{ iconName: "ContactInfo" }}
          />

          <PartnerContactsPanel isOpen={isContactOpen} onDismiss={dismissContactPanel} partnerOneName={props?.partnerOneName} />
        </div>
      </div>
    </div>
  );
}
